module.exports = __webpack_public_path__ + "media/assets/images/blog/Depositphotos_39406729_L-78c64c936df69959799d973601a8e8b9.jpg";